import HomePage from 'legacy/pages/HomePage'

HomePage.register()
